// extracted by mini-css-extract-plugin
export default {"changeDisclaimer":"vK-z","cltLink":"wK-z","shippingDisclaimer":"xK-z"};